import React, { useCallback, useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { DialogForm, IDialogActions, ISnackbarAlert, SelectField, SnackbarAlert, TextFieldInput, TextFieldReadOnly } from '../../../shared/components';
import { GenericService } from '../../../shared/services';
import { ListId, LocalStorange } from '../../../shared/environment';
import { TestAttributeValueDTO, TestAttributeValueFilterDTO, TestComponentDTO, TestComponentFilterDTO, UserDTO, ValueListDTO, ValueListFilterDTO } from '../../../shared/interfaces';
import { formatDateTime } from '../../../shared/utils';
import { TestAcceptanceCriteriaDTO } from '../../../shared/interfaces/testingSphere/TestAcceptanceCriteriaDTO';

interface ITestAcceptanceCriteriaMaintenanceProps {
    data: any;
    parentId?: string;
    setIsOpenMaintenance: (value: boolean) => void;
    isOpenMaintenance: boolean;
    setActionExecuted: (value: boolean) => void;
}

export const TestAcceptanceCriteriaMaintenance: React.FC<ITestAcceptanceCriteriaMaintenanceProps> = ({ data, parentId, isOpenMaintenance, setIsOpenMaintenance, setActionExecuted }) => {
    const [testComponentList, setTestComponentList] = useState<TestComponentDTO[]>([]);
    const [testAttributeValueList, setTestAttributeValueList] = useState<TestAttributeValueDTO[]>([]);
    const [conditionList, setConditionList] = useState<ValueListDTO[]>([]);
    const [userList, setUserList] = useState<UserDTO[]>([]);

    const [testAcceptanceCriteriaDTO, setTestAcceptanceCriteriaDTO] = useState<TestAcceptanceCriteriaDTO>();

    const [loading, setLoading] = useState(false);
    const [snackBarAlert, setSnackBarAlert] = useState<ISnackbarAlert>();
    const [isOpenMessage, setIsOpenMessage] = useState(false);

    const userInfo = JSON.parse(localStorage.getItem(LocalStorange.USERINFO) || '');

    useEffect(() => {
        setTestAcceptanceCriteriaDTO({
            ...testAcceptanceCriteriaDTO,
            id: '',
            testAttributeValueId: '',
            conditionId: '',
            outputTestAttributeValueId: '',
            valueToComparation: '',
            testComponentId: data ?? ''
        } as TestAcceptanceCriteriaDTO);

        if(isOpenMaintenance){
            handleTestComponentGetAllAsync();
            handleConditionGetAllAsync();
            handleUserGetAll();
            handleGetByIdAsync();
        }
    }, [data, isOpenMaintenance]);

    useEffect(() => {
        if (testAcceptanceCriteriaDTO?.testComponentId != '' || testAcceptanceCriteriaDTO?.testComponentId != undefined) {
            handleTestAttributeVallueGetAllViewAsync();
        }
    }, [testAcceptanceCriteriaDTO?.testComponentId]);

    const handleUserGetAll = useCallback(async () => {
        const filterUser = {
            companyId: userInfo.user.companyId,
        };
        GenericService.GetAllAsync1('authsphere.user', filterUser, setLoading, setUserList, showMessage);
    }, []);

    const handleTestComponentGetAllAsync = useCallback(async () => {
        const testComponentFilterDTO = {
            testScenarioId: parentId ?? '',
            orderBy: 'orderExecution'
        };
        GenericService.GetAllAsync1('testingsphere.testcomponent', testComponentFilterDTO, setLoading, setTestComponentList, showMessage);
    }, [parentId]);

    const handleTestAttributeVallueGetAllViewAsync = useCallback(async () => {
        if(!testAcceptanceCriteriaDTO?.testComponentId)
            return;
        
        const testAttributeValueFilterDTO: TestAttributeValueFilterDTO = {
            testComponentId: testAcceptanceCriteriaDTO?.testComponentId ?? '',
        };
        GenericService.GetAllViewAsync1('testingsphere.testattributevalue', testAttributeValueFilterDTO, setActionExecuted, setLoading, setTestAttributeValueList, showMessage, false);
    }, [testAcceptanceCriteriaDTO?.testComponentId]);

    const handleConditionGetAllAsync = useCallback(async () => {
        const valueListFilterDTO: ValueListFilterDTO = {
            listId: ListId.testingsphere.testacceptancecriteria.condition,
            orderBy: 'value'
        };
        GenericService.GetAllAsync1('parmsphere.valuelist', valueListFilterDTO, setLoading, setConditionList, showMessage);
    }, []);

    const handleGetByIdAsync = useCallback(async () => {
        GenericService.GetByIdAsync1('testingsphere.testacceptancecriteria', data.id, setLoading, setTestAcceptanceCriteriaDTO, showMessage);
    }, [data]);

    const handleSaveClick = useCallback(async () => {
        const dto = testAcceptanceCriteriaDTO as TestAcceptanceCriteriaDTO;
        if (testAcceptanceCriteriaDTO?.outputTestAttributeValueId !== '' && testAcceptanceCriteriaDTO?.outputTestAttributeValueId !== undefined)
            dto.valueToComparation = '';

        if (testAcceptanceCriteriaDTO?.id === '' || testAcceptanceCriteriaDTO?.id === undefined) {
            dto.createdById = userInfo.user.id;
            GenericService.AddAsync1('testingsphere.testacceptancecriteria', dto, setTestAcceptanceCriteriaDTO, setActionExecuted, setLoading, showMessage);
        }
        else {
            dto.updatedById = userInfo.user.id;
            GenericService.UpdateAsync1('testingsphere.testacceptancecriteria', dto, setActionExecuted, setLoading, showMessage);
        }
    }, [testAcceptanceCriteriaDTO]);

    function showMessage(message: string, type: 'error' | 'info' | 'success' | 'warning') {
        const msg: ISnackbarAlert = {
            id: 'message',
            message: message,
            type: type,
        };
        setSnackBarAlert(msg);
        setIsOpenMessage(true);
    }

    const actions: IDialogActions[] = [
        { id: 'save', text: 'Save', icon: 'save_outlined', iconColor: 'primary', setAction: handleSaveClick },
        { id: 'cancel', text: 'Cancel', icon: 'cancel_outlined', iconColor: 'secondary', setAction: () => void undefined },
    ];

    return (
        <React.Fragment>
            {isOpenMessage && (
                <SnackbarAlert
                    snackBarAlert={snackBarAlert}
                    setIsOpen={setIsOpenMessage}
                    isOpen={isOpenMessage}
                />
            )}
            <DialogForm
                title='TEST ACCEPTANCE CRITERIA DETAILS'
                icon='offline_pin_outlined'
                setIsOpen={setIsOpenMaintenance}
                isOpen={isOpenMaintenance}
                fullWidth={true}
                maxWidth={'lg'}
                actions={actions}
                loading={loading}
            >
                <React.Fragment>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={12}>
                            <SelectField
                                id='testComponentId'
                                label='Test Component Name'
                                value={testAcceptanceCriteriaDTO?.testComponentId}
                                setValue={setTestAcceptanceCriteriaDTO}
                                obj={testAcceptanceCriteriaDTO}
                                valueList={testComponentList}
                                autoFocus={true}
                                // disabled={data ?? testAcceptanceCriteriaDTO?.id ? true : false}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <SelectField
                                id='testAttributeValueId'
                                label='Test Attribute Value Name'
                                value={testAcceptanceCriteriaDTO?.testAttributeValueId}
                                setValue={setTestAcceptanceCriteriaDTO}
                                obj={testAcceptanceCriteriaDTO}
                                valueList={testAttributeValueList}
                                valueKey='id'
                                labelKey='attribute'
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <SelectField
                                id='conditionId'
                                label='Condition'
                                value={testAcceptanceCriteriaDTO?.conditionId}
                                setValue={setTestAcceptanceCriteriaDTO}
                                obj={testAcceptanceCriteriaDTO}
                                valueList={conditionList}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <SelectField
                                id='outputTestAttributeValueId'
                                label='Output TestAttributeValue'
                                value={testAcceptanceCriteriaDTO?.outputTestAttributeValueId}
                                setValue={setTestAcceptanceCriteriaDTO}
                                obj={testAcceptanceCriteriaDTO}
                                valueList={testAttributeValueList}
                                hasNoneSelect={true}
                                valueKey='id'
                                labelKey='attribute'
                            />
                        </Grid>
                        {!testAcceptanceCriteriaDTO?.outputTestAttributeValueId ? (
                            <React.Fragment>
                                <Grid item xs={12} md={12}>
                                    <TextFieldInput
                                        id='valueToComparation'
                                        label='Value to Comparation'
                                        value={testAcceptanceCriteriaDTO?.valueToComparation}
                                        setValue={setTestAcceptanceCriteriaDTO}
                                        obj={testAcceptanceCriteriaDTO}
                                        required={true}
                                        maxLength={200}
                                    />
                                </Grid>
                            </React.Fragment>
                        ) : undefined}
                        {testAcceptanceCriteriaDTO?.id ? (
                            <React.Fragment>
                                <Grid item xs={12} md={4}>
                                    <TextFieldReadOnly
                                        id={'id'}
                                        label='Id'
                                        value={testAcceptanceCriteriaDTO.id}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <TextFieldReadOnly
                                        id={'createdById'}
                                        label='Created By'
                                        value={userList.find(x => x.id === testAcceptanceCriteriaDTO.createdById)?.userName}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <TextFieldReadOnly
                                        id={'creationDateTime'}
                                        label='Creation Date'
                                        value={formatDateTime(String(testAcceptanceCriteriaDTO.creationDateTime))}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <TextFieldReadOnly
                                        id={'updatedById'}
                                        label='Updated By'
                                        value={userList.find(x => x.id === testAcceptanceCriteriaDTO.updatedById)?.userName}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <TextFieldReadOnly
                                        id={'updateDateTime'}
                                        label='Update Date'
                                        value={formatDateTime(String(testAcceptanceCriteriaDTO.updateDateTime))}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                            </React.Fragment>
                        ) : undefined}
                    </Grid>
                </React.Fragment>
            </DialogForm>
        </React.Fragment>
    );
};